// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eZzK_","recognized":"style_recognized__tEzEa","check":"style_check__jYl6i","notYou":"style_notYou__Y2dwk"};